import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

export const SelectsWrapperStyled = styled(FlexContainer)`
  gap: 1rem;
  width: 100%;
  margin: 20px 0;
`;
